import React from 'react';
import { Animated, View } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { AnimatedVFText } from '../VFText';

const ViewOptions = {
  view: Animated.View,
  image: Animated.Image,
  text: AnimatedVFText,
};

class AnimationView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      AnimValue: new Animated.Value(props.from),
      visible: false,
    };
  }

  componentDidMount() {
    const { to, duration, start, run, easing } = this.props;
    if (run) {
      this.setState({ visible: true }, () => {
        this.animate(to, duration, start, easing).start();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { run, to, duration, start, from, easing, oneWay } = this.props;
    const { visible } = this.state;

    if (run) {
      if (!visible) {
        this.setState({ visible: true });
      }
      this.animate(to, duration, start, easing).start();
    } else if (prevProps.run) {
      this.setState(
        {
          AnimValue: new Animated.Value(oneWay ? from : to),
        },
        () => {
          this.animate(oneWay ? to : from, duration, start, easing).start(() => {
            this.setState({ visible: false });
          });
        },
      );
    }
  }

  animate = (to, duration, delay, easing) => {
    return Animated.timing(this.state.AnimValue, {
      toValue: to,
      duration,
      delay: delay,
      easing,
      useNativeDriver: false,
    });
  };

  render() {
    const { AnimValue, visible } = this.state;
    const {
      effect,
      scroll,
      interpolateValues,
      type = 'view',
      accessibilityLabel,
      ...extraProps
    } = this.props;
    let animationsEffects;
    if (interpolateValues && interpolateValues.length > 0 && AnimValue) {
      const transform = [];
      animationsEffects = interpolateValues
        .map(value => {
          const obj = {
            [value.effect]: AnimValue.interpolate({
              inputRange: value.inputRange,
              outputRange: value.outputRange,
            }),
          };
          if (value.type === 'transform') {
            transform.push(obj);
            return;
          }
          return obj;
        })
        .reduce((prev, current) => {
          return { ...prev, ...current };
        });
      animationsEffects = {
        ...animationsEffects,
        ...(effect ? { [effect]: AnimValue } : {}),
        transform,
      };
    } else {
      animationsEffects = effect ? { [effect]: AnimValue } : {};
    }

    const AnimationViewType = ViewOptions[type];
    const _extraProps = type === 'image' || type === 'text' ? extraProps : {};
    const AnimationComp = (
      <AnimationViewType
        accessibilityLabel={accessibilityLabel}
        useNativeDriver
        {..._extraProps}
        style={{ ...this.props.style, ...animationsEffects }}
      >
        {this.props.children}
      </AnimationViewType>
    );
    return scroll && !visible ? (
      <View accessibilityLabel={accessibilityLabel} testID={accessibilityLabel} />
    ) : (
      AnimationComp
    );
  }
}

AnimationView.defaultProps = {
  type: 'view',
  duration: 350,
  accessibilityLabel: FoundationTestKeys.animationView,
  from: 0,
};

AnimationView.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  from: PropTypes.number,
  to: PropTypes.number,
  duration: PropTypes.number,
  start: PropTypes.number,
  run: PropTypes.bool,
  scroll: PropTypes.bool,
  effect: PropTypes.string,
  interpolateValues: PropTypes.array,
  easing: PropTypes.any,
  oneWay: PropTypes.bool,
  type: PropTypes.oneOf(['view', 'image', 'text']),
  accessibilityLabel: PropTypes.string,
};

export default AnimationView;
